export const enum LocalStorageKeys {
  SourceCode = 'sourceCode',
  CatalogLayout = 'catalogLayout',
  CatalogRecentlyUsed = 'catalogRecentlyUsed',
  CanvasLayout = 'canvasLayout',
  CanvasSidebarWidth = 'canvasSidebarWidth',
  RestDslNavWidth = 'restDslNavWidth',
  NavigationExpanded = 'navigationExpanded',
  SelectedCatalog = 'selectedCatalog',
  Settings = 'settings',
}
